import { AsyncStateNotification } from '@ui/notifications';
import { createSonarSelector } from '@lib/selectors';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
const stateSelector = createSonarSelector((state) => state.integrations.jira.initiatives.sync.post);
export const PostJiraIssueSyncNotifications = () => React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_POST_INITIATIVE_JIRA_SYNC, failed: NOTIFICATIONS_COPY.FAILED_POST_INITIATIVE_JIRA_SYNC, resetRawAction: integrationsActions.resetPostInitiativesSyncJiraIssue, stateSelector: stateSelector });
